export default __webpack_public_path__ + "static/media/u_wdt_c_5.93ebec5d.mp3";